import permissions from "../../data/permissions" ;
export default [
    {
        path: 'roles',
        name: 'Roles',
        component: () => import("./../../views/administration/RoleListView.vue"),
        meta: { requiresAuth: true, authorization: permissions.role.read }

    },
    {
        path: 'role',
        name: 'Role', 
        component: () => import("./../../views/administration/RoleCreateView.vue"),
        meta: { requiresAuth: true, authorization: permissions.role.create }

    },
    {
        path: 'role/:id',
        name: 'RoleDisplay',
        component: () => import("./../../views/administration/RoleDisplayView.vue"),
        meta: { requiresAuth: true, authorization: permissions.role.read }

    },
    {
        path: 'role/:id/edit',
        name: 'RoleEdit',
        component: () => import("./../../views/administration/RoleEditView.vue"),
        meta: { requiresAuth: true, authorization: permissions.role.update }

    }
]